import { render, staticRenderFns } from "./capexopex.vue?vue&type=template&id=3dde6b48&"
import script from "./capexopex.vue?vue&type=script&lang=js&"
export * from "./capexopex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports